import { findElement } from '../../format/elements';
import { useBuilder } from '../context';
import { GeneralSection } from './GeneralSection';
import { DefaultValueSection } from './DefaultValueSection';
import { Stack } from '@mui/material';
import { SettingsSection } from './SettingsSection';
import { OptionsSection } from './OptionsSection';
import { ValidationSection } from './ValidationSection';

export const ElementDrawer = ({ id }: { id: string }) => {
  const { form } = useBuilder();
  const element = findElement(form, id);
  if (!element) return null;
  return (
    <Stack spacing={2}>
      <GeneralSection element={element} />
      {element.kind === 'field' && (
        <>
          <OptionsSection field={element} />
          <SettingsSection field={element} />
          <DefaultValueSection field={element} />
        </>
      )}
      {element.kind === 'field' && <ValidationSection field={element} />}
    </Stack>
  );
};
